import { useMemo } from 'react';

import { isDealStage } from '../../../listing-stage/types';
import { useListingStages } from '../../../listing-stage/use-listing-stages.query';

export const useDealStatuses = () => {
  const { data: statuses = [] } = useListingStages();

  return useMemo(
    () => statuses.filter(status => isDealStage(status.name)),
    [statuses],
  );
};
